import { create } from "zustand"

interface authStore {
  isLoggedIn: boolean;
  setIsLoggedIn: (state: boolean) => void;
  isAuthChecked: boolean;
  setIsAuthChecked: (state: boolean) => void;
  isAuthorized: boolean;
  setIsAuthorized: (state: boolean) => void;
  authChecked: boolean;
  setAuthChecked: (state: boolean) => void;
  logoutReason: string | null;
  setLogoutReason: (state: string | null) => void;
}

const useAuthStore = create<authStore>((set) => ({
  isLoggedIn: false,
  setIsLoggedIn: (state) => set(() => ({ isLoggedIn: state })),
  isAuthChecked: false,
  setIsAuthChecked: (state) => set(() => ({ isAuthChecked: state })),
  isAuthorized: true,
  setIsAuthorized: (state) => set(() => ({ isAuthorized: state })),
  authChecked: false,
  setAuthChecked: (state) => set(() => ({ authChecked: state })),
  logoutReason: null,
  setLogoutReason: (state) => set(() => ({ logoutReason: state })),
}))

export {
  useAuthStore
}
